import { useCallback, useId } from "react";

import { ModalType } from "entities/common";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setModalCallbacks } from "store/slices/modalCallbacksRegistry";
import { showModal } from "store/slices/modalSlice";

export const useGuardedNavigation = () => {
  const dispatch = useAppDispatch();
  const blocked = useAppSelector((state: RootStore) => state.navGuard.blocked);
  const callbackKey = useId();

  return useCallback(
    (action: () => void) => {
      if (!blocked) {
        action();
        return;
      }

      setModalCallbacks(callbackKey, { onClick: action, onClick2: () => undefined });
      dispatch(
        showModal({
          modalType: ModalType.NOTICE,
          modalProps: {
            title: "Unsaved changes",
            description:
              "You have unsaved changes. If you leave now, your changes will be lost. Do you want to continue without saving?",
            buttonText: "Leave",
            buttonText2: "Stay",
            callbackKey,
          },
        }),
      );
    },
    [blocked, callbackKey, dispatch],
  );
};
